import { h } from 'preact';
import register from '@wcd/preact-custom-element';
import { useState } from 'preact/hooks';
import { useContext } from './context';
import { BuyResource } from '../../../types/web-components';
import { emitClickBuy } from '../shared/mz-helper';
import { TESCookieV2 } from '../shared/cookies';

const renderLink: any = ({ text, url, onClick, resourceid }) => {
  const referrer = typeof window!== 'undefined'
      ? document.referrer || window.location.href 
      : '';
  return (
  <div>
    <a
      href={url}
      onClick={onClick}
      className="rdp-cta__primary-btn tds-btn tds-btn--lg tds-btn--block tds-btn--primary-consent"
      rel="nofollow"
      data-name="rdp.buy_now"
      data-product-area="resources"
      data-tracking-id="rdp.buy_now"
      data-tracking-event="click"
      data-entity-id={resourceid}
      data-entity-type="resource"
      data-referrer={referrer}
    >
      {text}
    </a>
  </div>
);
}
export const component : BuyResource = ({ resourceid, children }) => {
  const [owns, setOwns] = useState(false);
  const [isAuthor, setIsAuthor] = useState(false);
  const [isElement, setIsElement] = useState(false);
  const [isElementFreebie, setIsElementFreebie] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isInteractive, setIsInteractive] = useState(false);

  const { userId } = TESCookieV2() || {};

  useContext(({ user, resource }) => {
    setOwns(Boolean(user?.owns));
    setIsElement(Boolean(resource?.isElement));
    setIsElementFreebie(Boolean(resource?.isElementFreebie));
    setIsAuthor(Boolean(userId === resource?.authorId));

    const userSubscriptions = user?.subscriptions;
    const resourceSubscriptions = resource?.availableThroughSubscriptionProduct;

    const userIsSubscribed = userSubscriptions?.find((userSubscription) =>
      resourceSubscriptions?.includes(userSubscription)
    );

    setIsSubscribed(Boolean(userIsSubscribed));
    setIsInteractive(Boolean(resource?.isInteractive));
  }); 

  // if no context, leave the content as-is.
  if (owns === null) return <div>{children}</div>;

  // If the author is browsing their own resource, render an edit button that redirects to the editor
  // and the download button
  if (isAuthor) {
    return (
      <div>
        <div className="rdp-cta__hidden-mobile">
          {renderLink({ text: 'Edit', url: `/uploader/v2/${resourceid}`})}
        </div>
        {renderLink({ text: 'Download',  url: `download/${resourceid}`})}
      </div>
    );
  };

  // Download if already owned, let the user download.
  if (owns) return renderLink({
    text: 'Download',
    url: `download/${resourceid}`,
  });

  // Elements - subscriptions
  // Launch an 'interactive' resource, or render the Download element button
  if (isSubscribed || isElementFreebie) {
    if (isInteractive) return renderLink({ text: 'Launch', url: `launch/${resourceid}` });
    else return renderLink({ text: 'Download', url: `download/${resourceid}`});
  }

  // Redirect to the elements subscription page.
  if (isElement) return renderLink({ text: 'Subscribe', url: `/store/elements` });

  // Otherwise, let the user buy.
  return renderLink({
    text: 'BUY NOW',
    url: `checkout/${resourceid}`,
    onClick: () => emitClickBuy(),
    resourceid: `${resourceid}`,
  });
};

register(component, 'tes-buy-resource', ['resourceid'], { shadow: false });